import { useQuery } from '@tanstack/react-query'
import { getCryptoInvoices } from '../services'
import { CryptoInvoiceQueryKeys } from '../../keys'

import type { GetCryptoInvoicesRequest } from '../../type'

export default function useQueryGetCryptoInvoices(
	payload: GetCryptoInvoicesRequest,
) {
	return useQuery({
		queryKey: [CryptoInvoiceQueryKeys.CryptoInvoices, payload],
		queryFn: () => getCryptoInvoices(payload),
	})
}
